<template> 
  <div>
    <div>
      <el-upload v-if="!imageUrl" 
                 :action="dataObj.host"
                 :data="dataObj"
                 list-type="picture"
                 :accept="accept"
                 :multiple="false"
                 :show-file-list="false"
                 :file-list="fileList"
                 :before-upload="beforeUpload"
                 :on-remove="handleRemove"
                 :on-success="handleUploadSuccess"
                 :on-progress="handleUploadProgress"
                 :on-preview="handlePreview">
        <!-- <el-button size="small"
                   type="primary"
                   style="float: right;">上传图片</el-button> -->
        <!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过10MB</div>-->
        <div class="upload-area">
          <div class="upload-icon">+</div>
          {{title}}
          <span v-if="remark"
                class="remark">点击上传或将表情图片拖动到此区域</span>
        </div>
      </el-upload>
      <div v-else class="avatar-uploader">
        <img :src="imageUrl" class="avatar"/>
        <div class="closeIcon" @click="handleRemove">
          <img src="@/assets/images/ic_tuichu@3x.png" alt=""/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="fileList[0].url">
    </el-dialog>
  </div>
</template>
<script>
import ossApi from '@/api/apiModel/upload'

export default {
  name: 'singleUpload',
  props: {
    value: String,
    showList: {
      type: Boolean,
      default: true
    },
    showImg: {
      type: Boolean,
      default: false
    },
    title: String,
    remark: {
      type: Boolean,
      default: false
    },
    accept: {
        type: String,
        default: ''
      },
  },
  computed: {
    imageUrl () {
      return this.value;
    },
    imageName () {
      if (this.value != null && this.value !== '') {
        return this.value.substr(this.value.lastIndexOf("/") + 1);
      } else {
        return null;
      }
    },
    fileList () {
      return [{
        name: this.imageName,
        url: this.imageUrl
      }]
    },
    showFileList: {
      get: function () {
        return this.value !== null && this.value !== '' && this.value !== undefined && this.showList;
      },
      set: function (newValue) {
      }
    }
  },
  data () {
    return {
      dataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: ''
      },
      dialogVisible: false
    };
  },
  created () {
    this.getNum();
  },
  methods: {
    emitInput (val) {
      this.$emit('input', val)
    },
    handleRemove (file, fileList) {
      this.emitInput('')
    },
    handlePreview (file) {
      this.dialogVisible = true
    },
    beforeUpload (file) {
      let _self = this
      // 验证文件格式
      const isJpg = file.type === "image/jpeg";
      const isPng = file.type === "image/png";
      // 验证文件大小（5MB）
      const isSize = file.size / (1024 * 1024) < 5;
      if (!isJpg && !isPng) {
        this.$message.error('上传失败，只能上传jpg/png格式的图片');
        return false;
      }
      if (!isSize) {
        this.$message.error('上传失败，最大只能上传5MB大小的图片');
        return false;
      }
      // 验证图片像素
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const { width, height } = img;
          if (width > 3000 || height > 3000) {
            _self.$message.error('上传失败，图片像素不能超过 3000 × 3000');
            reject(false);
          } else {
            ossApi.policy().then(response => {
              _self.dataObj.policy = response.result.policy;
              _self.dataObj.signature = response.result.signature;
              _self.dataObj.ossaccessKeyId = response.result.accessKeyId;
              _self.dataObj.callback = response.result.callback;
              _self.dataObj.key = response.result.dir + '/' + file.uid + _self.numGetInfo;
              _self.dataObj.dir = response.result.dir;
              _self.dataObj.host = response.result.host;
              resolve(true);
            }).catch(err => {
              console.log(err);
              reject(false);
            });
          }
        };
        img.onerror = () => {
          _self.$message.error('图片加载失败，请重新选择');
          reject(false);
        };
        img.src = URL.createObjectURL(file);
      });
    },
    handleUploadProgress (e, file, fileList) {
      this.$emit('changeProgress',e.percent)
    },
    handleUploadSuccess (res, file) {
      this.$emit('changeProgress',{percent:0})

      this.showFileList = this.showList
      this.fileList.pop()
      this.fileList.push({
        // name: file.uid + file.name,
        // url: this.dataObj.host + '/' + this.dataObj.dir + '/' + file.uid + file.name
        name: file.uid + this.numGetInfo,
        url: this.dataObj.host + '/' + this.dataObj.dir + '/' + file.uid + this.numGetInfo
      })
      this.emitInput(this.fileList[0].url)
      let obj = {
        url:this.fileList[0].url,
        appendixName:file.name,
        appendixSize:file.size,
        appendixType: 1
        // appendixType: file.name.replace(/.+\./, "")
      }
      this.$emit('emitEmailInput',obj)
    },
    getNum () {
      do
        var out = Math.floor(Math.random() * 10000);
      while (out < 1000)
      this.numGetInfo = out;
    }
  }
}
</script>
<style scoped>
.img_upload {
  width: 32px;
  height: 32px;
}
.remark {
  font-size: 14px;
  color: #7a7c80;
}
.avatar-uploader {
  position: relative;
  display: inline-block;
  padding: 20px;
}
.avatar {
  width: 100px;
  height: auto;
  border-radius: 2px;
}
.closeIcon {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background: white;
  border-radius: 50%;
  padding: 2px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.closeIcon img {
  width: 16px;
  height: 16px;
}
.upload-area {
  display: inline-block;
  width: 100px;
  height: 100px;
  cursor: pointer;
  border: 1px dashed #d9d9d9;
  border-radius: 2px;
  text-align: center;
  transition: border-color 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.upload-area:hover {
  border-color: #409eff;
}
.upload-icon {
  font-size: 24px;
  color: #999;
  margin-bottom: 5px;
}
</style>
